import { Pipe, PipeTransform } from '@angular/core';
import { HelperService } from './service/helper/helper.service';

@Pipe({
    name: 'convertnit'
})
export class NitPipe implements PipeTransform {
    constructor(public helper: HelperService) { }

    transform(value: any, args?: any): any {
        // let helper = HelperService;
        
        if(!value){
            value = 0;
        }
        value = value.toString()
        return this.helper.web3.utils.fromWei(value)
        // return value / 1000000000000000000;
    }
}